import { Component, inject } from '@angular/core';
import { KeyValuePipe } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { RouterLink } from '@angular/router';
import { LANGUAGE_NAMES } from '@core/constants/language';
import { isSupportedLanguage, Language } from '@core/enums/language';
import { Storage } from '@core/services/storage';
import { environment } from '@environments/environment';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { setHtmlLangAttribute } from '@utils/html';
import { navigateToLocationWithLang, withLanguageParam } from '@utils/location';
import { getActiveLanguage } from '@utils/translate';

@Component({
  selector: 'app-header',
  templateUrl: './header.html',
  styleUrl: './header.scss',
  imports: [RouterLink, MatMenuModule, KeyValuePipe, TranslatePipe]
})
export class Header {
  private translateService = inject(TranslateService);
  private storageService = inject(Storage);

  protected languages = LANGUAGE_NAMES;

  get currentLang(): Language {
    return getActiveLanguage(this.translateService) as Language;
  }

  constructor() {
    setHtmlLangAttribute(this.currentLang);
  }

  onChangeLang(languageCode: string) {
    if (!isSupportedLanguage(languageCode)) {
      return;
    }

    this.storageService.setLanguage(languageCode);
    navigateToLocationWithLang(languageCode);
  }

  logInByUrl() {
    this.navigateTo(withLanguageParam(environment.loginUrl, this.currentLang));
  }

  protected navigateTo(url: string): void {
    window.location.href = url;
  }
}
